import { useQuery } from '@tanstack/react-query';
import { useTenant } from "../../../contexts/TenantContext";
import useErrorHandler from '../../../hooks/useErrorHandler';
import apiClient from "../../../services/apiClientService";
import { Routes } from '../../../routes/RouteConstants';
import { SCHEDULE_MAX_AGE_MS } from '../../../hooks/useRefreshWhenStale';

// Guests keep booking while the dashboard sits open, so the list is re-asked on the same
// cadence as the schedule grid (`SCHEDULE_MAX_AGE_MS`). One provider's, as the calendar beside it;
// every ['pendingBookings'] key is invalidated together, whichever provider it is for.
const useGetBookings = (status, { enabled = true, providerId } = {}) => {
  const { tenantId } = useTenant();
  const { handleError } = useErrorHandler();

  const fetchBookings = async (tenantId, status, providerId) => {
    const url = `/v1/tenants/${tenantId}/bookings`;
    try {
      const response = await apiClient.get(url, { params: { status, providerId } });
    return response.data;
    } catch (error) {
      handleError(error, Routes.DASHBOARD);
      throw error;
    }
  };

  return useQuery({
    queryKey: ['pendingBookings', providerId],
    queryFn: () => fetchBookings(tenantId, status, providerId),
    enabled: !!tenantId && enabled, // don't run until tenantId exists
    staleTime: SCHEDULE_MAX_AGE_MS,
    refetchInterval: SCHEDULE_MAX_AGE_MS,
  });
};

export default useGetBookings;
